var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ContainerType } from "@/models/Container";
import { PackingCategory } from "@/models/Item";
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import Component from 'vue-class-component';
require('vue-multiselect');
Vue.use(BootstrapVue);
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { Watch } from "vue-property-decorator";
import ItemCardComponent from "@/components/item-card/ItemCard.vue";
import * as Ladda from 'ladda';
var PackingComponent = /** @class */ (function (_super) {
    __extends(PackingComponent, _super);
    function PackingComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.items = [];
        _this.packed = [];
        _this.hasStarted = false;
        _this.tripLength = 0;
        _this.tabIndex = 0;
        _this.underwearAndSocks = [PackingCategory.Underwear, PackingCategory.Socks];
        _this.normalClothes = [PackingCategory.Shirts, PackingCategory.Trousers, PackingCategory.Skirts];
        _this.outsideClothes = [PackingCategory.Jacket];
        _this.shoesAndOthers = [PackingCategory.Shoes, PackingCategory.Accessories, PackingCategory.Other];
        return _this;
    }
    PackingComponent.prototype.created = function () {
        this.loadContainerData();
    };
    PackingComponent.prototype.loadContainerData = function () {
        var _this = this;
        this.container = this.$store.state.containers.list.find(function (el) { return el.type == ContainerType.Default; });
        if (this.container) {
            this.$dao.getContainerItems(this.container).then(function (data) {
                _this.items = data;
            });
        }
    };
    PackingComponent.prototype.onTabIndexChange = function (val) {
        if (val === 0) {
            this.hasStarted = false;
        }
    };
    PackingComponent.prototype.startPacking = function () {
        var _this = this;
        this.$validator.validateAll().then(function (result) {
            if (result) {
                _this.chooseDefault();
                _this.hasStarted = true;
                _this.$nextTick(function () {
                    _this.tabIndex++;
                });
            }
        }).catch(function () {
            return false;
        });
    };
    PackingComponent.prototype.chooseDefault = function () {
        this.packed = [];
        var _loop_1 = function (packingCategory) {
            if (Number(packingCategory) || Number(packingCategory) == 0) {
                var filtered = this_1.items.filter(function (item) {
                    return String(item.packingCategory != null ? item.packingCategory : null) == packingCategory;
                });
                var multiplier = this_1.getMultiplier(packingCategory);
                var numberToPack = this_1.calculateDefaultQuantity(multiplier);
                for (var i = 0; i < (numberToPack > filtered.length ? filtered.length : numberToPack); i++) {
                    this_1.packed.push(filtered[i]);
                    // this.items.splice(this.items.indexOf(filtered[i]),1);
                }
            }
        };
        var this_1 = this;
        for (var packingCategory in PackingCategory) {
            _loop_1(packingCategory);
        }
    };
    PackingComponent.prototype.isPacked = function (item) {
        return ~this.packed.indexOf(item);
    };
    PackingComponent.prototype.toggleItem = function (item) {
        var index = this.packed.indexOf(item);
        if (index < 0) {
            this.packed.push(item);
        }
        else {
            this.packed.splice(index, 1);
        }
    };
    PackingComponent.prototype.calculateDefaultQuantity = function (multiplier) {
        return Math.ceil(this.tripLength * multiplier);
    };
    PackingComponent.prototype.filterByCategories = function (categories, array) {
        return array.filter(function (x) {
            return categories.includes(x.packingCategory);
        });
    };
    PackingComponent.prototype.getMultiplier = function (category) {
        if (category == PackingCategory.Underwear
            || category == PackingCategory.Socks
            || category == PackingCategory.Shirts) {
            return 1.2;
        }
        if (category == PackingCategory.Trousers
            || category == PackingCategory.Skirts) {
            return 0.4;
        }
        if (category == PackingCategory.Shoes
            || category == PackingCategory.Jacket) {
            return 0.1;
        }
        return 0;
    };
    PackingComponent.prototype.finishPacking = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var l, btn, travelContainer;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        l = null;
                        btn = this.$refs.saveBtn;
                        if (btn instanceof HTMLButtonElement) {
                            l = Ladda.create(btn);
                            l.start();
                        }
                        travelContainer = this.$store.state.containers.list.find(function (el) { return el.type == 2; });
                        return [4 /*yield*/, Promise.all(this.packed.map(function (item) {
                                return _this.$dao.moveItem(item, travelContainer);
                            }))];
                    case 1:
                        _a.sent();
                        if (l) {
                            l.stop();
                        }
                        this.$store.commit('setOnTrip', this.packed.length > 0);
                        this.$router.push({ name: 'container', params: { id: travelContainer.id } });
                        return [2 /*return*/];
                }
            });
        });
    };
    PackingComponent.prototype.cancelPacking = function () {
        var defaultContainer = this.$store.state.containers.list.find(function (el) { return el.type == ContainerType.Default; });
        this.$router.push({ name: 'container', params: { id: defaultContainer.id } });
    };
    __decorate([
        Watch('tabIndex')
    ], PackingComponent.prototype, "onTabIndexChange", null);
    PackingComponent = __decorate([
        Component({
            components: {
                'item-card': ItemCardComponent
            }
        })
    ], PackingComponent);
    return PackingComponent;
}(Vue));
export default PackingComponent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./src/components/packing/component.ts
// module id = null
// module chunks = 